import React, { forwardRef } from 'react';
import PhoneInput, { PhoneInputProps } from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';
import { Box } from '@mui/material';

interface CustomPhoneInputProps extends PhoneInputProps {
    error?: boolean;
    size?: 'small' | 'large';
    label?: string;
}

export const PhoneInputWrapper = forwardRef<HTMLInputElement, CustomPhoneInputProps>((props, ref) => {
    const { error, size, value, ...rest } = props;

    return (
        <Box
            sx={{
                width: '100%',
                '& .special-label': {
                    top: '-12px',
                },
                '& .react-tel-input .form-control': {
                    width: '100%',
                    color: 'common.grey1',
                    borderWidth: '1px',
                    borderColor: error ? 'common.system.error.main' : 'common.grey2',
                    paddingLeft: '44px',
                    '&:hover': {
                        borderColor: error ? 'common.system.error.main' : 'common.grey2',
                    },
                    '&:focus': {
                        borderColor: error ? 'common.system.error.main' : 'common.grey2',
                        boxShadow: 'none',
                        caretColor: `common.primary !important`,
                    },
                },
                '& .react-tel-input .special-label': {
                    left: '10px',
                    color: error ? 'common.system.error.main' : 'common.grey1',
                    fontSize: '12px',
                },
            }}
        >
            <PhoneInput
                {...rest}
                value={value || ''}
                inputProps={{
                    ref: ref as React.RefObject<HTMLInputElement>,
                }}
                inputStyle={{
                    fontSize: '14px',
                    height: '48px',
                }}
                specialLabel={props.label}
                country='us'
                onlyCountries={['us']}
                masks={{ us: '(...) ...-....' }}
                disableDropdown
                onChange={(value, country, e, formattedValue) => {
                    if (props.onChange) {
                        if (value.length) {
                            props.onChange(`+${value}`, country, e, formattedValue);
                        } else {
                            props.onChange(value, country, e, formattedValue);
                        }
                    }
                }}
            />
        </Box>
    );
});

PhoneInputWrapper.displayName = 'PhoneInputWrapper';
